<template>
  <div class="k-navbar__dropdown" v-click-outside="close">
    <button
      class="k-navbar__profile-btn"
      @click="toggle"
      aria-label="Profil"
    >
      <div class="k-navbar__avatar">
        <img :src="avatarSrc" :alt="userName" />
      </div>
      <svg class="k-navbar__caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <polyline points="6,9 12,15 18,9" />
      </svg>
    </button>
    <div v-if="isOpen" class="k-navbar__dropdown-menu k-navbar__dropdown-menu--right">
      <div class="k-navbar__dropdown-header">
        <span class="k-navbar__user-name">{{ userName }}</span>
        <span class="k-navbar__user-email">{{ userEmail }}</span>
      </div>
      <div class="k-navbar__dropdown-divider"></div>
      <router-link to="/profile" class="k-navbar__dropdown-item" @click.native="close">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </svg>
        Profil
      </router-link>
      <button class="k-navbar__dropdown-item" @click="handleLogout">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
          <polyline points="16,17 21,12 16,7" />
          <line x1="21" y1="12" x2="9" y2="12" />
        </svg>
        Abmelden
      </button>
    </div>
  </div>
</template>

<script>
/**
 * NavbarProfile - Profile dropdown component
 * @description User profile dropdown with avatar, name, and logout
 * @prop {String} userName - User display name
 * @prop {String} userEmail - User email address
 * @prop {String} avatarSrc - Avatar image source
 * @emits logout - When logout is clicked
 */
export default {
  name: "NavbarProfile",
  directives: {
    clickOutside: {
      bind(el, binding) {
        el.clickOutsideEvent = (event) => {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event);
          }
        };
        document.addEventListener("click", el.clickOutsideEvent);
      },
      unbind(el) {
        document.removeEventListener("click", el.clickOutsideEvent);
      },
    },
  },
  props: {
    userName: {
      type: String,
      default: "Max Mustermann",
    },
    userEmail: {
      type: String,
      default: "max@example.com",
    },
    avatarSrc: {
      type: String,
      default: "/img/default-avatar.png",
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    /**
     * Toggles dropdown visibility
     */
    toggle() {
      this.isOpen = !this.isOpen;
    },
    /**
     * Closes dropdown
     */
    close() {
      this.isOpen = false;
    },
    /**
     * Handles logout action
     */
    handleLogout() {
      this.$emit("logout");
      this.close();
    },
  },
};
</script>

